import { siteInfo } from "@/mocks/portal";

interface HeroProps {
  query: string;
  onQueryChange: (value: string) => void;
  onSubmit: (value: string) => void;
  onKeywordClick: (value: string) => void;
  keywords: string[];
  stats: { value: string; label: string }[];
}

export default function Hero({ query, onQueryChange, onSubmit, onKeywordClick, keywords, stats }: HeroProps) {
  return (
    <section id="top" className="relative w-full min-h-[88vh] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20editorial%20background%20with%20flowing%20amber%20and%20cream%20gradient%20shapes%2C%20subtle%20paper%20grain%20texture%2C%20soft%20diffused%20light%2C%20minimalist%20modern%20composition%20with%20generous%20negative%20space%2C%20calm%20inviting%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=kl-hero-2026&orientation=landscape"
        alt="看料入口 内容直达门户 暖色调抽象背景"
        title="看料入口 内容直达门户"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/65"></div>

      <div className="relative z-10 w-full max-w-content mx-auto px-4 md:px-6 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/12 border border-background-50/25 px-3.5 py-1.5 text-xs md:text-sm text-background-100 backdrop-blur">
            <i className="ri-flashlight-line"></i>
            {siteInfo.slogan}
          </span>

          <h1 className="mt-5 font-heading font-black text-background-50 text-shadow-soft text-3xl md:text-5xl lg:text-6xl leading-tight">
            看料入口
            <span className="block mt-2 text-xl md:text-3xl lg:text-4xl font-bold text-background-100">
              免跳转 · 秒进的直达通道
            </span>
          </h1>

          <p className="mt-5 text-sm md:text-base text-background-100/90 leading-relaxed max-w-2xl">
            热门料、新料、分类料一站聚合。输入关键词即可直接命中内容，省去层层查找的麻烦，页面响应快，浏览顺滑不卡顿。
          </p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit(query);
            }}
            className="mt-7 flex flex-col sm:flex-row gap-2.5 sm:gap-3 max-w-xl"
            role="search"
          >
            <label htmlFor="hero-search" className="sr-only">
              搜索内容
            </label>
            <div className="relative flex-1">
              <i className="ri-search-2-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 text-lg"></i>
              <input
                id="hero-search"
                name="keyword"
                type="text"
                value={query}
                onChange={(e) => onQueryChange(e.target.value)}
                placeholder="搜索热点、剧集、新机、赛事关键词…"
                className="w-full rounded-md border border-background-200 bg-background-50 pl-11 pr-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              <i className="ri-cursor-line"></i>
              立即直达
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs md:text-sm text-background-100/80">热门直达：</span>
            {keywords.map((word) => (
              <button
                key={word}
                type="button"
                onClick={() => onKeywordClick(word)}
                className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs md:text-sm text-background-100 backdrop-blur cursor-pointer transition-colors hover:bg-background-50/20 hover:text-background-50"
              >
                {word}
              </button>
            ))}
          </div>

          <dl className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 max-w-2xl">
            {stats.map((s) => (
              <div key={s.label} className="animate-fade-up-slow">
                <dt className="font-heading text-xl md:text-2xl font-bold text-background-50">{s.value}</dt>
                <dd className="mt-1 text-xs md:text-sm text-background-100/80">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}